import { URL_PATH } from 'utils/constants';
import { useCallback, useState } from 'react';
import useAuth from 'hooks/useAuth';

export const useNavigateOrigin = () => {
  const { logout } = useAuth();
  const [loadingLogout, setLoadingLogout] = useState(false);

  const originRoute = URL_PATH;
  const navigateOrigin = useCallback(async () => {
    setLoadingLogout(false);
    await logout();
    setLoadingLogout(true);
    window.location.replace(originRoute);
  }, [originRoute]);

  return {
    loadingLogout,
    navigateOrigin,
    originRoute,
  };
};
